// extracted by mini-css-extract-plugin
export default {"selector":"CurrencySelector_selector__qygPe","option":"CurrencySelector_option__ozzRT"};